<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #app
    // 整体默认
    font-family "SourceHanSansCN", "SansSerif"
</style>



// WEBPACK FOOTER //
// src/App.vue